<form [formGroup]="scheduleForm" autocomplete="off">
  <!-- {{scheduleForm.value| json}} -->
  <h4>Time</h4>
  <div class="two-columns">
    <vue-select
      label="{{ 'label.placeholder.startTime' | translate | async }}"
      formControlName="startTime"
      [required]="true"
      [options]="utcStartTimes"
      [getOptionDisplay]="addUTCToTime.bind(this)"
      [errorMatcher]="suppressErrorState"
    ></vue-select>
    <vue-select
      label="{{ 'label.placeholder.endTime' | translate | async }}"
      formControlName="endTime"
      [required]="true"
      [options]="utcEndTimes"
      [getOptionDisplay]="addUTCToTime.bind(this)"
      [errorMatcher]="suppressErrorState"
    ></vue-select>
  </div>
  <div class="capacity">
    <h4>
      {{ 'title.capacity' | translate | async }}
    </h4>
  <div *ngIf="scheduleForm.controls.startTime.value && scheduleForm.controls.endTime.value">
    <mat-radio-group aria-label="Select an option"   [value]="selectedOptions"  (change)="selectedOption($event)">
  <mat-radio-button value="Hourly">Hourly</mat-radio-button>
  <mat-radio-button value="Minutes">15-Minute</mat-radio-button>
</mat-radio-group>
  </div>
    <p *ngIf="!scheduleForm.controls.startTime.value || !scheduleForm.controls.endTime.value">
      {{ 'message.addPool.capacity.instructions' | translate | async }}
    </p>
  </div>
  <div class="capacity-columns" *ngIf="this.selectedOptions == 'Hourly' ">
    <ng-container
      formArrayName="hourlyItems"
      class="capacity-slot"
      *ngFor="let capacity of capacityItems; let i=index">
      <label [for]="capacity.startTime">
        {{capacity.startTime}} – {{addUTCToTime(capacity.endTime)}}
      </label>
      <vue-numeric-input
        [id]="capacity.startTime"
        [formControl]="getItemControl(i)"
        [errorMatcher]="suppressErrorState"
        [compact]="true"
        [maxLength]="5"
      ></vue-numeric-input>
    </ng-container>
    <ng-container class="capacity-columns total-container">
      <p>
        {{ 'title.totalCapacity' | translate | async }} <br />
        <small>{{ 'title.appointmentsPerDay' | translate | async }}</small>
      </p>
      <p class="total">{{totalCapacity}}</p>
    </ng-container>
  </div>
  <div class="capacity-columns" *ngIf="this.selectedOptions == 'Minutes' ">
     <ng-container
      formArrayName="minuteItems"
      class="capacity-slot"
      *ngFor="let capacity of capacityItems; let i=index">
      <label [for]="capacity.startTime">
        {{capacity.startTime}}
      </label>
      <vue-numeric-input
        [id]="capacity.startTime"
        [formControl]="getItemControlmin(i)"
        [errorMatcher]="suppressErrorState"
        [compact]="true"
        [maxLength]="5"
      ></vue-numeric-input>
    </ng-container>
    <ng-container class="capacity-columns total-container">
      <p>
        {{ 'title.totalCapacity' | translate | async }} <br />
        <small>{{ 'title.appointmentsPerDay' | translate | async }}</small>
      </p>
      <p class="total">{{totalCapacityformin}}</p>
    </ng-container>
  </div>
</form>
